<template>
    <h1>
      <div class="header-empty"></div>
        <!-- 需要设计搞 -->
        未找到页面
    </h1>
</template>
<script>
export default {
  name: "page404",
  data() {
    return {};
  }
};
</script>


// WEBPACK FOOTER //
// src/components/page404.vue